module.exports = __webpack_public_path__ + "img/add-service-forms-new.47e673a5.svg";